module.exports = __webpack_public_path__ + "img/xt12@2x.8f4f9b37.png";